import Vue from 'vue';
import ImageLoader from './image_loader';

const lazyLoadDirective = {
  inserted(el, { value }) {
    ImageLoader(el, value);
  }
};

Vue.directive('lazy-load-image', lazyLoadDirective);

export default lazyLoadDirective;
